import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import {
  getEmails,
  getMessage,
  getShowEmailModal,
  getSubject,
  getUsers,
} from 'selectors/admin/work-orders/details/proposal';
import {
  addEmail,
  initializeEmailValues,
  removeEmail,
  sendEmail,
  setProposalMessage,
  setProposalSubject,
  setShowEmailModal,
} from 'actions/admin/work-orders/details/proposal';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import Button from 'components/shared/button/Button';
import { WorkOrder } from 'domain/work-order';
import './ProposalEmailModal.css';
import {
  getSelectedProposalId,
  getSelectedProposalNumber,
} from 'selectors/admin/work-orders/details/proposal-approval';
import { EmailEditor } from 'components/shared/email/EmailEditor';

class ProposalEmailModal extends Component {
  handleSend = () => {
    this.props
      .dispatch(
        sendEmail(
          this.props.selectedProposalId,
          this.props.emails,
          this.props.subject,
          this.props.message
        )
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(setShowEmailModal(false));

          this.props.dispatch(
            initializeEmailValues(
              this.props.selectedProposalNumber,
              this.props.currentWorkOrder.number,
              this.props.currentWorkOrder.name,
              this.props.currentWorkOrder.building.location,
              this.props.currentWorkOrder.client.company_name,
              this.props.users
            )
          );
        }
      });
  };

  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(setShowEmailModal(false));
  };

  handleAddCustomEmail = (email) => {
    this.props.dispatch(addEmail(email));
  };

  handleToEmailRemove = (email) => {
    this.props.dispatch(removeEmail(email));
  };

  handleAddUserEmail = (email) => {
    this.props.dispatch(addEmail(email));
  };

  handleSubjectConfirm = (subject) => {
    this.props.dispatch(setProposalSubject(subject));
  };

  handleMessageChange = (message) => {
    this.props.dispatch(setProposalMessage(message));
  };

  isSendButtonEnabled = () => {
    return (
      this.props.emails.length > 0 &&
      this.props.subject !== '' &&
      this.props.message !== ''
    );
  };

  render() {
    const woName = WorkOrder.getName(this.props.currentWorkOrder);
    const title = `Proposal (WO #${this.props.currentWorkOrder.number}${
      woName !== null ? `: ${woName}` : ''
    })`;
    return this.props.showEmailModal ? (
      <FormModal
        className="proposal-email-modal"
        show={this.props.showEmailModal}
        title={title}
        onClose={this.handleClose}
      >
        <div className="proposal-email-container">
          <EmailEditor
            toEmails={this.props.emails}
            message={this.props.message}
            subject={this.props.subject}
            usersEmail={this.props.users.map((user) => user.email)}
            onCustomEmailAdd={this.handleAddCustomEmail}
            onMessageChange={this.handleMessageChange}
            onSubjectConfirm={this.handleSubjectConfirm}
            onToEmailRemove={this.handleToEmailRemove}
            onUserEmailAdd={this.handleAddUserEmail}
          />

          <div className="button-container">
            <Button
              className="button-orange"
              disabled={!this.isSendButtonEnabled()}
              label="Send"
              onClick={this.handleSend}
            />
          </div>
        </div>
      </FormModal>
    ) : null;
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    emails: getEmails(state),
    message: getMessage(state),
    selectedProposalId: getSelectedProposalId(state),
    selectedProposalNumber: getSelectedProposalNumber(state),
    showEmailModal: getShowEmailModal(state),
    subject: getSubject(state),
    users: getUsers(state),
  };
})(ProposalEmailModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/ProposalEmailModal.js